import { Component, Input, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/dashboard/dashboard.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { DashboardResponsiveApiModelSparse, WorkspaceNewTabViewMode } from 'src/shared/models/dashboard.model';

@Component({
    selector: 'cv-open-existing-dashboard',
    templateUrl: './open-existing-dashboard.component.html',
    styleUrls: ['./open-existing-dashboard.component.scss']
})
export class OpenExistingDashboardComponent implements OnInit {
    @Input() workspaceKey;

    searchFilter = '';
    selectedDashboards: DashboardResponsiveApiModelSparse[] = [];

    // temp for testing share
    dashboardsToAssign: DashboardResponsiveApiModelSparse[] = [];
    showAssignTool = false;

    get hasCreatePermission() { return this.dashboardService.permissions.DashboardNew; }
    get workspaceNewTabViewMode() { return WorkspaceNewTabViewMode; }

    constructor(
        private dashboardService: DashboardService,
        private cvLocalizationService: CVLocalizationService
    ) {
        this.cvLocalizationService.GetSection("Dashboards_Landing");
    }

    ngOnInit() {

    }

    /** Check if there are available space to open a new dashboard page */
    get canCreateNewDashboard() {
        const dashboardOpened = this.dashboardService.dashboards.filter(d => d != null);
        return dashboardOpened.length < this.dashboardService.maxAttachedDashboards;
    }

    /** Displays a tooltip for the create new dashboard button depending on its state */
    get createTooltip(): string {
        if (this.canCreateNewDashboard)
            return "";

        return this.cvLocalizationService.Format(
            this.cvLocalizationService.getCachedText(
                'Dashboards_Landing',
                'Create_Tooltip',
                `You already have {0} dashboards open. Close a tab in order to be able to create a new dashboard.`
            ),
            this.dashboardService.maxAttachedDashboards
        );
    }

    clearSearch() {
        this.searchFilter = '';
    }

    openNewDashboardView(previousTab = null) {
        this.dashboardService.newTabSelectionView = WorkspaceNewTabViewMode.New;
        if (previousTab) {
            this.dashboardService.newDashboardPreviousView = previousTab;
        } else {
            this.dashboardService.newDashboardPreviousView = WorkspaceNewTabViewMode.Landing;
        }
    }

    backToLanding() {
        this.dashboardService.newTabSelectionView = WorkspaceNewTabViewMode.Landing;
    }

    onShareClickedTemp(dashboards: DashboardResponsiveApiModelSparse[]) {
        console.error("QA PLEASE REPORT IF SEEN!!! TODO: remove testing share button... (disable management)", dashboards);
        this.dashboardsToAssign = dashboards;
        this.showAssignTool = true;
    }
}
